module.exports = __webpack_public_path__ + "static/lee-e1b7b2de07e8dc0f629298a0461d33ad.jpg";